import PCPFinance from './pcp';
import JAFPCPFinance from './jafpcp';
import JAFPCPTelematicsFinance from './jafpcp-telematics';
// import SIMPLYDRIVEFinance from './simplydrive';
// import SIMPLYDRIVETelematicsFinance from './simplydrive-telematics';
import HPFinance from './hp';
// import HPStandardFinance from './hpstandard';

/**
 * Helper method to return an object representing the keys we want to show on the used more details page. We can order the keys here, change the short and long name, set the fallback mileage/deposit/terms if the CW request fails to get that key, and determine if the finance option should show if the key is not available for the vehicle
 * @param {object} vehicle
 */
export default function(vehicle) {
    if (vehicle.brand == 'vauxhall') {
        return [
            new PCPFinance(vehicle),
            new HPFinance(vehicle),
            // new HPStandardFinance(vehicle),
        ];
    }
    if (vehicle.brand == 'peugeot') {
        return [
            new PCPFinance(vehicle),
            new JAFPCPFinance(vehicle),
            new JAFPCPTelematicsFinance(vehicle),
            new HPFinance(vehicle),
            // new HPStandardFinance(vehicle),
        ];
    }
    if (vehicle.brand == 'ds') {
        return [
            new PCPFinance(vehicle),
            // new SIMPLYDRIVEFinance(vehicle),
            // new SIMPLYDRIVETelematicsFinance(vehicle),
            new HPFinance(vehicle),
            // new HPStandardFinance(vehicle),
        ];
    }
    if (vehicle.brand == 'citroen') {
        return [
            new PCPFinance(vehicle),
            // new SIMPLYDRIVEFinance(vehicle),
            // new SIMPLYDRIVETelematicsFinance(vehicle),
            new HPFinance(vehicle),
            // new HPStandardFinance(vehicle),
        ];
    }

    return [
        new PCPFinance(vehicle),
        new HPFinance(vehicle),
        // new HPStandardFinance(vehicle),
    ];
}